export default __webpack_public_path__ + "static/media/telegram-blue.aa1bdce1.svg";